import template from "./entity-modal.html";
import "./entity-modal.less";
import tabbedModal from "../../modals/tabbed-modal";
import entityModalTabs from "./tabs";
import { EVENT_LOGOUT } from "../../../constants";
import { FORM_ENTITY } from "routes.js";
import {
	buildEntitySavePayload,
	mergeSavedEntity
} from "../entity-save-payload";

export function controller(loadingService, eventBus, $scope, appState, api, $location, $uibModal, toastr) {
	const ctrl = this;

	ctrl.promiseTracker = loadingService.getTracker();

	ctrl.handleClose = handleClose;
	ctrl.onCreate = onCreate;
	ctrl.$onInit = onInit;
	ctrl.$onDestroy = onDestroy;
	ctrl.isSyncUrl = isSyncUrl;
	ctrl.saveEntity = saveEntity;
	ctrl.allTypes = appState.forms.selected.Agency.Types;
	ctrl.overviewUnsavedChanges = undefined;

	function isSyncUrl() {
		return ctrl.resolve.syncUrl !== false;
	}

	function onInit() {
		ctrl.entity = ctrl.resolve.entity;
		ctrl.typeConfig = ctrl.resolve.typeConfig;
		ctrl.mode = ctrl.resolve.mode;
		if(ctrl.entity?.Id) {
			loadEntity();
		}

		eventBus.register(EVENT_LOGOUT, () => { forceClose(); }, $scope);

	}

	function onDestroy() {
		forceClose();
	}

	function forceClose() {
		ctrl.modalInstance.close(ctrl.entity);
	}

	async function handleClose(entity) {
		if(entity === undefined) {
			const confirmed = await checkOverviewDirty({ prompt: true });
			if(!confirmed) {
				return;
			}
		}
		ctrl.modalInstance.close(entity ?? ctrl.entity);
	}

	function loadEntity() {
		const promise = api.get(FORM_ENTITY(appState.forms.selected.Id, ctrl.entity.Id)).then((response) => {
			ctrl.entity = {
				...ctrl.entity,
				...response
			};
		});

		return loadingService.watch(promise);
	}

	function checkOverviewDirty(options) {
		if(!ctrl.overviewUnsavedChanges) {
			return Promise.resolve(true);
		}

		return ctrl.overviewUnsavedChanges.checkIfDirty(options);
	}

	function saveEntity(entity) {
		const route = FORM_ENTITY(appState.forms.selected.Id, entity.Id);
		const payload = buildEntitySavePayload(entity, ctrl.typeConfig);
		const promise = ctrl.putAndDirty(route, payload).then((savedEntity) => {
			const updatedEntity = mergeSavedEntity(entity, savedEntity ?? payload);

			ctrl.entity = updatedEntity;
			appState.updateEntity(updatedEntity);
			toastr.success(`${updatedEntity.Name ?? updatedEntity.Code} updated successfully.`);

			return updatedEntity;
		});

		return loadingService.watch(promise);
	}

	function onCreate(entity) {
		ctrl.modalInstance.close(entity);
	}

	ctrl.openRelatedEntity = async function(entity) {
		const agencyConfig = appState.forms.selected.Agency;
		const typeConfig = agencyConfig.Types.find(t => t.Code === entity.Type.Code);
		const canSync = isSyncUrl();

		// Save current URL state to restore when child modal closes
		const parentId = canSync ? $location.search().id : null;
		const parentHash = canSync ? $location.hash() : null;

		if(canSync) {
			$location.search("id", String(entity.Id))
				.hash("")
				.replace();
		}

		try {
			await $uibModal.open({
				component: "entity-modal",
				size: "lg",
				backdrop: "static",
				keyboard: false,
				resolve: {
					entity: () => entity,
					typeConfig: () => typeConfig,
					permissions: () => ctrl.resolve.permissions,
					syncUrl: () => canSync
				}
			}).result;
		}
		finally {
			if(canSync) {
				$location.search("id", parentId)
					.hash(parentHash || "")
					.replace();
			}
		}
	};

	ctrl.postAndDirty = async(...args) => {
		const result = await api.post(...args);
		appState.forms.isDirty = true;

		return result;
	};

	ctrl.putAndDirty = async(...args) => {
		const result = await api.put(...args);
		appState.forms.isDirty = true;

		return result;
	};
}

export default angular.module("vesl.components.entity-modal", [tabbedModal, entityModalTabs])
	.component("entityModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	})
	.name;
